import { reactive, toRefs } from 'vue'
import apiAuth from '../api/auth.api'
import useNats from '../store/nats.store'

const nats = useNats()

const state = reactive({
  isAuthenticated: false,
  user: null,
  allowedMenus: []
})

export default function () {
  function setSession ({
    token,
    profile,
    menus = [],
    nats,
  }) {
    state.isAuthenticated = true
    state.user = profile
    state.allowedMenus = menus.map(v => v.name)
    localStorage.setItem('token', token)
    // nats.subscribeNatsServer(nats)
  }

  function removeSession () {
    state.isAuthenticated = false
    state.user = null
    localStorage.removeItem('token')
  }

  async function getMe () {
    const { data: { token, profile, menus, nats } } = await apiAuth.getMe()
    return {
      token, 
      profile, 
      menus, 
      nats
    }
  }

  async function refreshUser () {
    const { data: { profile } } = await apiAuth.getMe()
    state.user = profile
  }

  async function login ({ email, password }) {
    const { data: { token, profile, menus, nats } } = await apiAuth.login({
      email,
      password
    })
    setSession({ token, profile, menus, nats })
    window.location.replace('/')
  }

  function logout () {
    removeSession()
    window.location.replace('/')
  }

  async function checkAuthentication () {
    return await getMe()
      .then(({ token, profile, menus, nats }) => {
        setSession({ token, profile, menus, nats })
      })
      .catch(() => {
        removeSession()
      })
    
  }

  return {
    ...toRefs(state),
    checkAuthentication,
    login,
    logout,
    refreshUser,
    removeSession
  }
}